export default __webpack_public_path__ + "static/media/arrow-left.fc8e8b38.svg";